import { appNav } from './app-nav/app-nav.module';
import { appComponent } from './app.component.js';
import { components } from './components/components.module';
import { libs } from './libs/libs.module';

export const app = angular
	.module('common.app', [
		appNav,
		components,
		libs
	])
	.component('app', appComponent)
	.config(($stateProvider) => {
		'ngInject';
		
		$stateProvider
			.state('app', {
				url: '/',
				component: 'app'
			});
	})
	.run(($state, $location, $transitions, AuthService, CompareObjectService, toastr, $anchorScroll) => {
		$transitions.onStart({
			to: 'app'
		}, (state) => {
			if (AuthService.isAuthenticated()) {
				$state.go('app.dashboard.DynamicMenus',{
                        url: 'home-banner'
                    });
				return true;
			} else {
				$state.go('app.login');
				return false;
			}
		});
		
		$transitions.onSuccess({
			to: '*'
		}, () => {
			$anchorScroll();
		});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/common/app.module.js